import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

import customButtonStyles from "components/CustomButton/styles";

const sectionDescriptionStyles = {
  text: (theme: Theme): SystemStyleObject<Theme> => ({
    "& .image-center": {
      margin: "0 auto",
      display: "block",
      maxWidth: "100%",
    },
    "& .column": {
      display: "grid",
      alignItems: "center",
      justifyItems: "center",
      gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
      columnGap: 4,
      rowGap: 1,
      my: 3,

      "&.column-reverse > img": {
        order: { md: 1 },
      },

      "& > *": {
        maxWidth: "100%",
      },
    },
    "& .text-small": {
      ...theme.typography.body2,
    },
    "& .button, & .button-outlined": {
      ...customButtonStyles.button(theme),
      ...customButtonStyles.primary(theme),
      ...(typeof theme.components?.MuiButton?.styleOverrides?.root === "object"
        ? (theme.components?.MuiButton?.styleOverrides
            ?.root as SystemStyleObject<Theme>)
        : {}),
      textDecoration: "none",
      my: 0.5,
      display: "flex",
      alignItems: "center",
      width: { sm: "fit-content" },
      justifyContent: "center",

      "&.icon-website::before, &.icon-web::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/website-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-instagram::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/instagram-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-twitter::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/twitter-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-opensea::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/opensea-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-facebook::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/facebook-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-tiktok::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/tiktok-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-spotify::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/spotify-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-youtube::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/youtube-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-x::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/x-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-discord::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/discord.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-telegram::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/telegram-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-medium::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/medium-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-apple::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/apple-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-swap::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/swap.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-community::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/community.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-linkedin::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/linkedin-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-shop::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/shop-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-ar::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/ar-icon.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-email::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/icon-email.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-whatsapp::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/icon-whatsapp.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
        mr: 1,
      },
      "&.icon-linktree::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/linktree.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
      },
      "&.icon-phone::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/phone.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
      },
      "&.icon-github::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/github.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
      },
      "&.icon-slack::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/slack.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
      },
      "&.icon-wechat::before": {
        content: "''",
        maskImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/icons/wechat.svg)`,
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        backgroundColor: "currentColor",
        height: 20,
        width: 20,
        display: "block",
      },
    },
  }),
};

export default sectionDescriptionStyles;
